import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PaymentService } from '../payment.service';

@Component({
  selector: 'app-add-payement',
  templateUrl: './add-payment.component.html',
  styleUrls: ['./add-payment.component.scss']
})
export class AddPaymentComponent implements OnInit{

  constructor( private dialogRef: MatDialogRef<AddPaymentComponent>,private stripeService:PaymentService) { }
  amount:number=0;
  loader=false;

ngOnInit(): void {
  
}
selectValue(arg0: number) {
  this.amount=arg0;
}
closeDialog() {
  this.dialogRef.close({ refresh: true });
}
  async checkout() {
    try {
      this.loader=true;
      const { sessionId } = await this.stripeService.createCheckoutSession(this.amount*100);
      await this.stripeService.redirectToCheckout(sessionId);
    } catch (error) {
      console.error('Error during checkout:', error);
    }
    this.loader=false;
  }
  

}
